<!-- 修改单价弹窗组件 -->
<template>
  <el-dialog title="修改单价" :visible.sync="dialogVisible" width="500px" append-to-body @close="handleClose"
    @opened="handleOpened">
    <!-- 商品信息展示 -->
    <div v-if="selectedCartItem"
      style="margin-bottom: 15px; padding: 10px; background: #f0f9ff; border-radius: 4px; border-left: 4px solid #409EFF;">
      <div style="color: #409EFF; font-weight: bold; margin-bottom: 5px;">商品信息：</div>
      <div style="color: #666; font-size: 14px;">
        {{ selectedCartItem.bgmName }} - {{ selectedCartItem.spec }}
      </div>
      <div style="color: #666; font-size: 14px;">
        当前单价：¥{{ selectedCartItem.changePrice || selectedCartItem.actualPrice || selectedCartItem.price }}
      </div>
    </div>

    <!-- 表单 -->
    <el-form id="priceEditForm" :model="form" :rules="rules" ref="priceEditFormRef" label-width="80px" size="small">
      <el-form-item label="单价" prop="price">
        <el-input ref="priceEditInput" v-model="form.price" type="number" style="width: 100%"
          @keydown.enter.native="handleConfirm" @keydown.down.native.prevent="focusNextInput('priceEditInput')"
          @keydown.up.native.prevent="focusConfirmButton" @input="calculate" />
      </el-form-item>

      <el-form-item label="账号" prop="username" v-if="isChangePriceCheck==1||(isChangePriceCheck==2&&isFlag)">
        <el-input ref="priceUsernameInput" v-model="form.username" autocomplete="off"
          :name="'price-username-' + Date.now()" autocapitalize="off" spellcheck="false"
          @keydown.enter.native="handleConfirm" @keydown.up.native.prevent="focusLastInput('priceUsernameInput')"
          @keydown.down.native.prevent="focusNextInput('priceUsernameInput')" />
      </el-form-item>

      <el-form-item label="密码" prop="password" v-if="isChangePriceCheck==1||(isChangePriceCheck==2&&isFlag)">
        <el-input ref="pricePasswordInput" v-model="form.password" type="password" show-password
          autocomplete="new-password" :name="'price-password-' + Date.now()" autocapitalize="off" spellcheck="false"
          @keydown.enter.native="handleConfirm" @keydown.up.native.prevent="focusLastInput('pricePasswordInput')"
          @keydown.down.native.prevent="focusConfirmButton" />
      </el-form-item>
    </el-form>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button ref="priceConfirmButton" type="primary" @click="handleConfirm"
        @keydown.up.native.prevent="focusLastInput('pricePasswordInput')" @keydown.enter.native="handleConfirm">
        确认修改
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'PriceEditDialog',
  props: {
    // 弹窗显示状态
    visible: {
      type: Boolean,
      default: false
    },
    // 是否验证修改价格
    isChangePriceCheck: {
      type: Number,
      default: false
    },
    // 选中的购物车商品
    selectedCartItem: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      // 表单数据
      form: {
        price: 0,
        username: '',
        password: '',
      },
      isFlag:false,
      // 表单验证规则
      rules: {
        price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = parseFloat(value);
              if (isNaN(num) || num < 0) {
                callback(new Error('单价不能小于0'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    // 监听选中商品变化，更新表单价格
    selectedCartItem: {
      handler(newItem) {
        if (newItem) {
          this.form.price = newItem.changePrice || newItem.actualPrice || newItem.price;
        }
      },
      immediate: true
    }
  },
  methods: {
    calculate(){
      var price=this.selectedCartItem.changePrice || this.selectedCartItem.actualPrice || this.selectedCartItem.price
      if (price>this.form.price) {
        this.isFlag=true
      }else{
        this.isFlag=false
      }
    },
    // 弹窗打开事件
    handleOpened() {
      this.$nextTick(() => {
        if (this.$refs.priceEditInput) {
          // 获取实际的input元素
          const inputElement = this.$refs.priceEditInput.$el.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      });
      // 添加键盘事件监听
      document.addEventListener('keydown', this.handleKeyDown);
      this.$emit('opened');
    },

    // 弹窗关闭事件
    handleClose() {
      // 清空表单数据
      this.form = {
        price: 0,
        username: '',
        password: ''
      };

      // 移除键盘事件监听
      document.removeEventListener('keydown', this.handleKeyDown);
      this.$emit('close');
    },

    // 确认修改
    handleConfirm() {
      this.$refs.priceEditFormRef.validate((valid) => {
        if (!valid) return;

        const newPrice = parseFloat(this.form.price);
        const credentials = {
          username: this.form.username,
          password: this.form.password
        };

        this.$emit('confirm', { price: newPrice, credentials,oldPsprice:  this.selectedCartItem.changePrice || this.selectedCartItem.actualPrice || this.selectedCartItem.price });
      });
    },

    // 聚焦到下一个输入框
    focusNextInput(currentRef) {
      const inputOrder = ['priceEditInput', 'priceUsernameInput', 'pricePasswordInput'];
      const currentIndex = inputOrder.indexOf(currentRef);
      const nextIndex = (currentIndex + 1) % inputOrder.length;
      const nextRef = inputOrder[nextIndex];

      this.$nextTick(() => {
        if (this.$refs[nextRef]) {
          const inputElement = this.$refs[nextRef].$el.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      });
    },

    // 聚焦到上一个输入框
    focusLastInput(currentRef) {
      const inputOrder = ['priceEditInput', 'priceUsernameInput', 'pricePasswordInput'];
      const currentIndex = inputOrder.indexOf(currentRef);
      const lastIndex = currentIndex === 0 ? inputOrder.length - 1 : currentIndex - 1;
      const lastRef = inputOrder[lastIndex];

      this.$nextTick(() => {
        if (this.$refs[lastRef]) {
          const inputElement = this.$refs[lastRef].$el.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      });
    },

    // 聚焦到确认按钮
    focusConfirmButton() {
      this.$nextTick(() => {
        if (this.$refs.priceConfirmButton) {
          this.$refs.priceConfirmButton.$el.focus();
        }
      });
    },

    // 键盘事件处理
    handleKeyDown(event) {
      // 处理ESC键关闭弹窗
      if (event.key === 'Escape') {
        event.preventDefault();
        this.dialogVisible = false;
      }
    }
  }
}
</script>

<style scoped>
::v-deep #priceEditForm .el-form-item__label {
  color: #606266 !important;
}

::v-deep #priceEditForm .el-form-item {
  margin-bottom: 15px !important;
}

.dialog-footer {
  text-align: right;
}

/* 表单样式优化 */
.el-form-item {
  margin-bottom: 20px;
}

/* 输入框聚焦样式 */
.el-input.is-focus .el-input__inner {
  border-color: #409EFF;
}

/* 按钮样式 */
.el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
}

.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}
</style>
